/**
 * List of features with id and condition.
 *
 * Condition will recieve rootState and rootGetters as parameters.
 *
 * @constant {Array.<{id: String, condition: Function}>}
 */
export const FEATURES = [
  // {
  //   id: 'testFeature',
  //   condition: (rootState, rootGetters) => rootState.order.checkoutVersion >= 2,
  // },
  {
    id: 'PhoneFormInputV2',
    condition: () => false,
  },
]

/**
 * Object of feature ids.
 *
 * @constant {Object}
 * */
export const FEATURE_IDS = FEATURES.reduce((ids, { id }) => {
  ids[id] = id
  return ids
}, {})
